import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=5bc16165"
import script from "./DetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports